module.exports = __webpack_public_path__ + "img/group.a033a5ad.png";